import { render, staticRenderFns } from "./LayoutInventory.vue?vue&type=template&id=cdbe498c&scoped=true"
import script from "./LayoutInventory.vue?vue&type=script&lang=js"
export * from "./LayoutInventory.vue?vue&type=script&lang=js"
import style0 from "./LayoutInventory.vue?vue&type=style&index=0&id=cdbe498c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdbe498c",
  null
  
)

export default component.exports